import * as actionTypes from '../actions/actionTypes';

import { RequestStatus } from '@interfaces/mainInterfaces';
import { IDashboardInformations } from '@interfaces/dashboardInterfaces';

import { updateObject } from '@utils/utils';

class InitialStateProps {
    espot: string = null;
    espotReorderTop = null;
    espotTop: string = null;
    espotBottom: string = null;
    getMyAccountDashboardEspotRequestStatus: RequestStatus = 'IDLE';

    dashboardInformations: IDashboardInformations = null;
    getDashboardInformationsRequestStatus: RequestStatus = 'IDLE';
}

const initialState: InitialStateProps = new InitialStateProps();

const dashboardReducer = (state = initialState, action): InitialStateProps => {
    switch (action.type) {
        case actionTypes.GET_MY_ACCOUNT_DASHBOARD_ESPOT_PENDING:
            return updateObject(state, {
                getMyAccountDashboardEspotRequestStatus: 'LOADING',
            });
        case actionTypes.GET_MY_ACCOUNT_DASHBOARD_ESPOT_SUCCESS:
            return updateObject(state, {
                getMyAccountDashboardEspotRequestStatus: 'SUCCESS',
                espot: action.espot,
            });
        case actionTypes.GET_MY_ACCOUNT_DASHBOARD_ESPOT_ERROR:
            return updateObject(state, {
                getMyAccountDashboardEspotRequestStatus: 'ERROR',
            });
        case actionTypes.GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_PENDING:
            return updateObject(state, {
                getMyAccountReorderTopDashboardEspotRequestStatus: 'LOADING',
            });
        case actionTypes.GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_SUCCESS:
            return updateObject(state, {
                getMyAccountReorderTopDashboardEspotRequestStatus: 'SUCCESS',
                espotReorderTop: action.espotReorderTop,
            });
        case actionTypes.GET_MY_ACCOUNT_REORDER_TOP_DASHBOARD_ESPOT_ERROR:
            return updateObject(state, {
                getMyAccountReorderTopDashboardEspotRequestStatus: 'ERROR',
            });
        case actionTypes.GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_PENDING:
            return updateObject(state, {
                getMyAccountTopDashboardEspotRequestStatus: 'LOADING',
            });
        case actionTypes.GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_SUCCESS:
            return updateObject(state, {
                getMyAccountTopDashboardEspotRequestStatus: 'SUCCESS',
                espotTop: action.espotTop,
            });
        case actionTypes.GET_MY_ACCOUNT_TOP_DASHBOARD_ESPOT_ERROR:
            return updateObject(state, {
                getMyAccountTopDashboardEspotRequestStatus: 'ERROR',
            });
        case actionTypes.GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_PENDING:
            return updateObject(state, {
                getMyAccountBottomDashboardEspotRequestStatus: 'LOADING',
            });
        case actionTypes.GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_SUCCESS:
            return updateObject(state, {
                getMyAccountBottomDashboardEspotRequestStatus: 'SUCCESS',
                espotBottom: action.espotBottom,
            });
        case actionTypes.GET_MY_ACCOUNT_BOTTOM_DASHBOARD_ESPOT_ERROR:
            return updateObject(state, {
                getMyAccountBottomDashboardEspotRequestStatus: 'ERROR',
            });
        case actionTypes.GET_DASHBOARD_INFORMATIONS_PENDING:
            return updateObject(state, {
                getDashboardInformationsRequestStatus: 'LOADING',
            });
        case actionTypes.GET_DASHBOARD_INFORMATIONS_SUCCESS:
            return updateObject(state, {
                getDashboardInformationsRequestStatus: 'SUCCESS',
                dashboardInformations: action.dashboardInformations,
            });
        case actionTypes.GET_DASHBOARD_INFORMATIONS_ERROR:
            return updateObject(state, {
                getDashboardInformationsRequestStatus: 'ERROR',
            });
        default:
            return state;
    }
};

export default dashboardReducer;
